import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../components/ui/alert-dialog";

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
    <div>
      <h1 className="font-heading font-semibold text-[22px] tracking-tight" style={{ color: "#0F2A6E", letterSpacing: "-0.01em" }}>{title}</h1>
      {subtitle && <p className="text-[13px] text-[#6B7A8D] mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const PageContainer = ({ children }) => (
  <div className="p-6 md:p-8 max-w-6xl mx-auto">{children}</div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-white border border-slate-200 rounded-2xl ${className}`} {...rest}>{children}</div>
);

export const StatCard = ({ label, value, sub }) => (
  <Card className="p-5">
    <div className="text-[10.5px] uppercase tracking-[0.16em] text-[#6B7A8D] font-semibold">{label}</div>
    <div className="mt-2 font-heading font-semibold text-[28px]" style={{ color: "#0F2A6E", letterSpacing: "-0.01em" }}>{value}</div>
    {sub && <div className="mt-1 text-[12px] text-[#6B7A8D]">{sub}</div>}
  </Card>
);

/**
 * Reusable delete confirmation built on shadcn AlertDialog.
 * Renders the trigger as-is (children) and shows a confirmation dialog before calling onConfirm.
 */
export function ConfirmDelete({ title = "Delete this item?", description = "This action cannot be undone.", onConfirm, children, testId }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent data-testid={testId ? `${testId}-dialog` : undefined}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={testId ? `${testId}-cancel` : undefined}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-[#1B6FE0] hover:bg-[#1657B3] text-white"
            data-testid={testId ? `${testId}-confirm` : undefined}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
